module.exports = __webpack_public_path__ + "img/header_bg1.6ec8cc6c.png";